/* CAVE — buy form enhancement. The form works without this file (native POST to
   /cart/add). This only keeps price, availability and the variant id in sync when
   the product has more than one option, and tells the sticky bar. It fires no
   tracking events of its own, so Shopify's analytics and installed pixels see
   each add-to-cart exactly once. */

class CaveBuyForm extends HTMLElement {
  connectedCallback() {
    const data = this.querySelector('script[data-variants]');
    this.variants = data ? JSON.parse(data.textContent) : [];
    this.select = this.querySelector('select[name="id"]');
    this.onChange = () => this.update();
    this.select?.addEventListener('change', this.onChange);
  }
  disconnectedCallback() { this.select?.removeEventListener('change', this.onChange); }
  update() {
    const v = this.variants.find((x) => String(x.id) === this.select.value);
    if (!v) return;
    const now = this.querySelector('[data-price-now]');
    const was = this.querySelector('[data-price-was]');
    if (now) { now.textContent = v.purchasable || !v.available ? v.price : ''; now.hidden = !now.textContent; now.closest('.cave-price')?.toggleAttribute('hidden', now.hidden); }
    if (was) { was.textContent = v.compare || ''; was.hidden = !v.compare; }
    let label = '';
    this.querySelectorAll('[data-buy-button]').forEach((btn) => {
      btn.disabled = !v.purchasable;
      label = v.purchasable ? btn.dataset.labelAvailable : v.available ? btn.dataset.labelPending : btn.dataset.labelSoldout;
      const span = btn.querySelector('[data-label]');
      if (span) span.textContent = label;
    });
    document.dispatchEvent(new CustomEvent('cave:variant', { detail: { formId: this.dataset.formId, variant: v, label } }));
    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url);
  }
}
if (!customElements.get('cave-buy-form')) customElements.define('cave-buy-form', CaveBuyForm);
